import React, { useMemo } from 'react';
import { FacilitiesAttribute } from '@gql/schema';
import {
  BadgeVariant,
  Badges,
  Typography,
  TypographyVariant,
  useTheme,
} from '@secretescapes/falcon';
import { useTranslations } from '@utils/useTranslations';
import { getAttributeText } from './Attribute.utils';

export const Attribute = ({ attribute }: { attribute: FacilitiesAttribute }) => {
  const theme = useTheme();
  const { translations } = useTranslations();

  const isUnavailable = attribute.key === 'unavailable';

  const attributeText = useMemo(
    () => getAttributeText(attribute, translations),
    [attribute, translations]
  );

  if (!attributeText) {
    return null;
  }

  return (
    <Badges
      variant={BadgeVariant.large}
      backgroundColor={isUnavailable ? theme.color.error05 : theme.color.grey05}
    >
      <Typography
        variant={TypographyVariant.body}
        color={isUnavailable ? theme.color.error50 : theme.color.blackText}
        component="span"
      >
        {attributeText}
      </Typography>
    </Badges>
  );
};
